﻿export const validationCheck = (
  { id, name, projectTypeIds, approvers } = {},
  isDuplicateName,
  hasInvalidProjectTypes
) => {
  let isValid =
    !isDuplicateName &&
    name &&
    projectTypeIds?.length &&
    !hasInvalidProjectTypes;

  if (!id) {
    isValid = isValid && approvers?.length;
  }

  return !!isValid;
};
